import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-quotes-reference-carousel]',
  swiperWrapper: '[data-swiper-wrapper]',
};

const classes = {
  swiperWrapper: 'swiper-wrapper',
  swiperPagination: '.swiper-pagination',
};

class QuotesAndReference extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(max-width:768px)');

      this.carouselWrappers = this.querySelector(selectors.carouselWrapper);
      this.swiperWrapper = this.querySelector(selectors.swiperWrapper);
      this.render();
    });
  }

  render() {
    if (typeof this.carousel !== 'undefined') {
      this.swiperWrapper.classList.remove(classes.swiperWrapper);
    }

    if (this.breakpoint.matches) {
      this.swiperWrapper.classList.add(classes.swiperWrapper);

      this.carousel = new Swiper(this.carouselWrappers, {
        modules: [Navigation, Pagination],
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        watchOverflow: true,
        pagination: {
          el: classes.swiperPagination,
          clickable: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 8,
          },
        },
      });
    }
  }
}

customElements.define('quotes-and-reference', QuotesAndReference);
